<template>
  <div class="inner-box">
    <div class="content-name">
      <h2 class="dp-ib">{{ title }}</h2>
      <div class="btn-wrap btn-type1 clearfix">
        <button class="btn-size btn-blue fl_left" @click="goSearch"><span class="btn-icon"><i
              class="fas fa-pen-alt"></i></span> 조회
        </button>
      </div>
    </div>

    <!-- 검색조건 영역 -->
    <div class="desc-content search-border">
      <div class="item desc-left">
        <div class="desc-item">
          <div class="tit">
            <span class="label-tit">방문목적</span>
          </div>
          <div class="desc" style="width: 70%">
            <b-select class="select is-fullwidth" v-model="form.purpose">
              <option value=''>==전체==</option>
              <option v-for="item in purposes" :key="item.key" :value="item.key" v-text="item.value" />
            </b-select>
          </div>
        </div>

        <div class="desc-item">
          <div class="tit">
            <span class="label-tit">진행상태</span>
          </div>
          <div class="desc" style="width: 70%">
            <b-select class="select is-fullwidth" v-model="form.visitStatCd">
              <option value=''>==전체==</option>
              <option v-for="item in visitStats" :key="item.key" :value="item.key" v-text="item.value" />
            </b-select>
          </div>
        </div>

        <div class="desc-item">
          <div class="tit">
            <span class="label-tit">신청일자</span>
          </div>
          <div class="desc">
            <div class="td-s-thumb search-area" style="width: 100%">
              <div class="datepicker w-type-ymd02">
                <dhx-calendar class="input ddate sDate" v-model="form.searchDtmFr"
                  :disabled="form.dtmChecked === false || form.dtmChecked == undefined" />
              </div>
              <span class="wave"> ~ </span>
              <div class="datepicker w-type-ymd02">
                <dhx-calendar class="input ddate sDate" v-model="form.searchDtmTo"
                  :disabled="form.dtmChecked === false || form.dtmChecked == undefined" />
              </div>
              <div class="btn-wrap btn-type2 clearfix"
                style="float:left; padding-left: 5px; padding-top: 2px; margin-bottom: 0px">
                <button class="btn-size btn-w-gray" @click="setRToday()"
                  style="height: 22px; padding: 0 8px; font-size: 12px"
                  :disabled="form.dtmChecked === false || form.dtmChecked == undefined">
                  오늘
                </button>
              </div>

              <div class="desc-item" style="display:inline-block;width:100px;margin-left:5px">
                <div class="tit">
                  <input type="checkbox" id="DtmChk" v-model="form.dtmChecked" /><label for="DtmChk">사용</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="desc-item">
          <div class="tit">
            <span class="label-tit">방문일자</span>
          </div>
          <div class="desc">
            <div class="td-s-thumb search-area" style="width: 100%">
              <div class="datepicker w-type-ymd02">
                <dhx-calendar class="input ddate sDate" v-model="form.searchVDtmFr"
                  :disabled="form.vdtmChecked === false || form.vdtmChecked == undefined" />
              </div>
              <span class="wave"> ~ </span>
              <div class="datepicker w-type-ymd02">
                <dhx-calendar class="input ddate sDate" v-model="form.searchVDtmTo"
                  :disabled="form.vdtmChecked === false || form.vdtmChecked == undefined" />
              </div>
              <div class="btn-wrap btn-type2 clearfix"
                style="float:left; padding-left: 5px; padding-top: 2px; margin-bottom: 0px">
                <button class="btn-size btn-w-gray" @click="setToday()"
                  style="height: 22px; padding: 0 8px; font-size: 12px"
                  :disabled="form.vdtmChecked === false || form.vdtmChecked == undefined">
                  오늘
                </button>
              </div>
              <div class="desc-item" style="display:inline-block;width:100px;margin-left:5px">
                <div class="tit">
                  <input type="checkbox" id="VDtmChk" v-model="form.vdtmChecked" /><label for="VDtmChk">사용</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item desc-center">
        <div class="desc-item" v-if="this.visitBookYn">
          <div class="tit">
            <span class="label-tit">접수유형</span>
          </div>
          <div class="desc" style="width: 70%">
            <b-select class="select is-fullwidth" v-model="form.visitTypeCd">
              <option value=''>==전체==</option>
              <option v-for="item in visitTypes" :key="item.key" :value="item.key" v-text="item.value" />
            </b-select>
          </div>
        </div>
        <div class="desc-item">
          <div class="tit">
            <span class="label-tit">방문회사</span>
          </div>
          <div class="desc" style="width: 70%">
            <b-select class="select is-fullwidth" v-model="form.visitCompCd">
              <option value=''>==전체==</option>
              <option value='100010'>일진전기</option>
              <option value='100002'>일진홀딩스</option>
              <option value='101301'>일진다이아</option>
              <option value='222300'>알피니언메디칼</option>
            </b-select>
          </div>
        </div>
        <search-dept-mg title="방문부서" v-model="form"
          :options="{ type: '01', deptCd: 'visitDept', deptNm: 'deptNm', authorize: true }" @submit="goSearch"
          style="width: 100%;" />
        <search-emp-mg title="피방문자" v-model="form"
          :options="{ type: '01', empNo: 'visitEmp', empNm: 'empNm', dutNm: 'wrtDutNm', deptNm: 'wrtCctrNm' }"
          @submit="goSearch" style="width: 100%;" />
      </div>
      <div class="item desc-right">
        <div class="desc-item" style="width: 80%">
          <div class="tit">
            <span class="label-tit">신청자명</span>
          </div>
          <div class="desc">
            <input class="input Rt-M tal" type="text" v-model="form.visitorFirstNm" @keypress.enter.prevent="goSearch">
          </div>
        </div>
        <div class="desc-item" style="width: 80%">
          <div class="tit">
            <span class="label-tit">방문자명</span>
          </div>
          <div class="desc">
            <input class="input Rt-M tal" type="text" v-model="form.visitorNm" @keypress.enter.prevent="goSearch">
          </div>
        </div>
        <div class="desc-item" style="width: 80%">
          <div class="tit">
            <span class="label-tit">전화번호</span>
          </div>
          <div class="desc">
            <input class="input Rt-M tal" type="text" v-model="form.visitorPhoneNum" @keypress.enter.prevent="goSearch">
          </div>
        </div>
        <div class="desc-item" style="width: 80%">
          <div class="tit">
            <span class="label-tit">회사명</span>
          </div>
          <div class="desc">
            <input class="input Rt-M tal" type="text" v-model="form.visitorComp" @keypress.enter.prevent="goSearch">
          </div>
        </div>
      </div>
    </div>
    <!-- //검색조건 영역 -->

    <!-- 테이블 -->
    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="table-name">
            <h3 class="ico_table_name">방문신청 목록</h3>
          </div>
          <div class="btn-wrap btn-type1 clearfix">
            <button class="btn-size btn-excel" @click="saveExcel">엑셀 저장</button>
          </div>
        </div>
        <div class="grid-wrap">
          <dhx-grid ref="grid" v-model="visitList" :config="configType"
            @constructGridSuccessful="constructGridSuccessful" />
        </div>
      </div>
    </div>
    <!-- //테이블 -->

    <!--팝업-->
    <b-modal :active.sync="showEmpModal" has-modal-card @receive="receiveEmp">
      <emp :param="form.draftNm"></emp>
    </b-modal>
    <!--//팝업 -->
  </div>
</template>

<script>
import mixin from '@/mixin';
import mixinSlip from '@/mixin/slip';
import _ from 'lodash'

import SearchDeptMg from '@/components/SearchDeptMg.vue';
import SearchEmpMg from '@/components/SearchEmpMg.vue';
import DhxCalendar from '@/components/DhxCalendar.vue'
import DhxGrid from '@/components/DhxGrid.vue'
import Emp from '@/components/Emp.vue';

export default {
  name: 'VisitMgList',
  mixins: [mixin, mixinSlip],
  components: { Emp, DhxGrid, DhxCalendar, SearchDeptMg, SearchEmpMg },
  data() {
    return {
      config: {
        columns: [
          { id: 'no', type: 'cntr', align: 'center', sort: 'na', value: 'No.', width: 35 },
          { id: 'visitNo', type: 'ro', align: 'center', sort: 'na', value: '방문번호', width: 120 },
          { id: 'regDtm', type: 'ro', align: 'center', sort: 'na', value: '신청일', width: 80 },
          { id: 'compCd', type: 'ro', align: 'center', sort: 'na', value: '회사코드', width: 100, hide: true },
          { id: 'compNm', type: 'ro', align: 'center', sort: 'na', value: '방문회사', width: 100 },
          { id: 'visitDeptNm', type: 'ro', align: 'center', sort: 'na', value: '방문부서', width: 150 },
          { id: 'visitEmpNm', type: 'ro', align: 'center', sort: 'na', value: '피방문자', width: 80 },
          { id: 'visitorFirstNm', type: 'ro', align: 'center', sort: 'na', value: '신청자명', width: 80 },
          { id: 'visitorComp', type: 'ro', align: 'center', sort: 'na', value: '신청자회사', width: 150 },
          { id: 'visitorCompAddr', type: 'ro', align: 'center', sort: 'na', value: '회사주소', width: 150 },
          { id: 'staYmd', type: 'ron', align: 'center', sort: 'na', value: '시작일', width: 80 },
          { id: 'staTime', type: 'ro', align: 'center', sort: 'na', value: '시작시간', width: 60 },
          { id: 'endYmd', type: 'ro', align: 'center', sort: 'na', value: '종료일', width: 80 },
          { id: 'endTime', type: 'ro', align: 'center', sort: 'na', value: '종료시간', width: 60 },
          { id: 'purposeNm', type: 'ro', align: 'center', sort: 'na', value: '방문목적', width: 120 },
          { id: 'content', type: 'ro', align: 'center', sort: 'na', value: '내용', width: 200 },
          { id: 'aprverNm', type: 'ro', align: 'center', sort: 'na', value: '결재차례', width: 100 },
          { id: 'visitStatNm', type: 'ro', align: 'center', sort: 'na', value: '진행상태', width: 100 },
        ],
        height: 483,
        enablePaging: true,
        pagingSize: 12,
        afterRefreshData(grid, data) {
          this.$nextTick(() => {
            _.forEach(data, (item, index) => {
              let rId = index + 1
              grid.cells(rId, 2).setValue(this.$moment(grid.cells(rId, 2).getValue()).format('YYYY-MM-DD'))
              grid.cells(rId, 10).setValue(this.$moment(grid.cells(rId, 10).getValue()).format('YYYY-MM-DD'))
              grid.cells(rId, 12).setValue(this.$moment(grid.cells(rId, 12).getValue()).format('YYYY-MM-DD'))
              if (grid.cells(rId, 11).getValue()) grid.cells(rId, 11).setValue(this.$moment(grid.cells(rId, 11).getValue(), 'HHmm').format('HH:mm'))
              if (grid.cells(rId, 13).getValue()) grid.cells(rId, 13).setValue(this.$moment(grid.cells(rId, 13).getValue(), 'HHmm').format('HH:mm'))
            })
          })
        }
      },
      configBook: {
        columns: [
          { id: 'no', type: 'cntr', align: 'center', sort: 'na', value: 'No.', width: 35 },
          { id: 'visitNo', type: 'ro', align: 'center', sort: 'na', value: '방문번호', width: 120 },
          { id: 'regDtm', type: 'ro', align: 'center', sort: 'na', value: '신청일', width: 80 },
          { id: 'visitTypeNm', type: 'ro', align: 'center', sort: 'na', value: '접수유형', width: 80 },
          { id: 'compCd', type: 'ro', align: 'center', sort: 'na', value: '회사코드', width: 100, hide: true },
          { id: 'compNm', type: 'ro', align: 'center', sort: 'na', value: '방문회사', width: 100 },
          { id: 'visitDeptNm', type: 'ro', align: 'center', sort: 'na', value: '방문부서', width: 150 },
          { id: 'visitEmpNm', type: 'ro', align: 'center', sort: 'na', value: '피방문자', width: 80 },
          { id: 'visitorFirstNm', type: 'ro', align: 'center', sort: 'na', value: '신청자명', width: 80 },
          { id: 'visitorComp', type: 'ro', align: 'center', sort: 'na', value: '신청자회사', width: 150 },
          { id: 'visitorCompAddr', type: 'ro', align: 'center', sort: 'na', value: '회사주소', width: 150 },
          { id: 'staYmd', type: 'ron', align: 'center', sort: 'na', value: '시작일', width: 80 },
          { id: 'staTime', type: 'ro', align: 'center', sort: 'na', value: '시작시간', width: 60 },
          { id: 'endYmd', type: 'ro', align: 'center', sort: 'na', value: '종료일', width: 80 },
          { id: 'endTime', type: 'ro', align: 'center', sort: 'na', value: '종료시간', width: 60 },
          { id: 'purposeNm', type: 'ro', align: 'center', sort: 'na', value: '방문목적', width: 120 },
          { id: 'content', type: 'ro', align: 'center', sort: 'na', value: '내용', width: 200 },
          { id: 'aprverNm', type: 'ro', align: 'center', sort: 'na', value: '결재차례', width: 100 },
          { id: 'visitStatNm', type: 'ro', align: 'center', sort: 'na', value: '진행상태', width: 100 },
        ],
        height: 483,
        enablePaging: true,
        pagingSize: 12,
        afterRefreshData(grid, data) {
          this.$nextTick(() => {
            _.forEach(data, (item, index) => {
              let rId = index + 1
              grid.cells(rId, 2).setValue(this.$moment(grid.cells(rId, 2).getValue()).format('YYYY-MM-DD'))
              grid.cells(rId, 11).setValue(this.$moment(grid.cells(rId, 11).getValue()).format('YYYY-MM-DD'))
              grid.cells(rId, 13).setValue(this.$moment(grid.cells(rId, 13).getValue()).format('YYYY-MM-DD'))
              if (grid.cells(rId, 12).getValue()) grid.cells(rId, 12).setValue(this.$moment(grid.cells(rId, 12).getValue(), 'HHmm').format('HH:mm'))
              if (grid.cells(rId, 14).getValue()) grid.cells(rId, 14).setValue(this.$moment(grid.cells(rId, 14).getValue(), 'HHmm').format('HH:mm'))
            })
          })
        }
      },
      title: '마곡빌딩 방문리스트',
      params: {},
      docTypes: [],
      purposes: [],
      visitTypes: [],
      visitStats: [],
      visitList: [],
      visitBookYn: '',
      sortAsc: 'Y',
      checked: 'checked',
      showEmpModal: false,
      form: {
        docTypeCd: '',
        purpose: '',
        visitTypeCd: '',
        visitStatCd: '',
        searchDtmFr: this.$moment().add(-1, 'month').format('YYYY-MM-DD'),
        searchDtmTo: this.$moment().format('YYYY-MM-DD'),
        searchVDtmFr: this.$moment().add(-1, 'month').format('YYYY-MM-DD'),
        searchVDtmTo: this.$moment().add(1, 'month').format('YYYY-MM-DD'),
        visitCompCd: '',
        visitDept: '',
        visitEmp: '',
        visitorFirstNm: '',
        visitorComp: '',
        visitorNm: '',
        visitorPhoneNum: '',
        dtmUse: '',
        vdtmUse: '',
        dtmChecked: true,
        vdtmChecked: true,
      },
    }
  },
  methods: {
    constructGridSuccessful(grid) {
      //this.config.queryPage(0)

      grid.setColumnHidden(10, true)
      grid.setColumnHidden(12, true)

      grid.attachEvent('onRowDblClicked', (rId) => {
        let visitNo = grid.cells(rId, 1).getValue()
        this.$router.push({ path: `/backOffice/visitMngMg/${visitNo}` })
      })
      grid.attachEvent('onHeaderClick', (cId) => {
        if (this.sortAsc === 'Y') {
          grid.sortRows(cId, "str", "des")
          this.sortAsc = 'N'
        } else {
          grid.sortRows(cId, "str", "asc")
          this.sortAsc = 'Y'
        }
      })
    },
    getPurposeCdCombo() {
      this.$http.get(`/api/code/combo`, { params: { groupCd: "PURPOSE_CD" } })
        .then(response => {
          this.purposes = response.data
        })
    },
    getVisitTypeCdCombo() {
      this.$http.get(`/api/code/combo`, { params: { groupCd: "VISIT_TYPE_CD" } })
        .then(response => {
          this.visitTypes = response.data
        })
    },
    getVisitStatCdCombo() {
      this.$http.get(`/api/code/combo`, { params: { groupCd: "VISIT_STAT_CD" } })
        .then(response => {
          this.visitStats = response.data
        })
    },
    getDocTypeCombo() {
      this.$http.get(`/api/code/combo`, { params: { groupCd: "VISIT_TYPE_CD" } })
        .then(response => {
          this.docTypes = response.data
        })
    },
    saveExcel() {
      this.downloadExcel(this.$refs.grid)
    },
    goSearch() {
      if (this.form.dtmChecked)
        this.form.dtmUse = 'Y'
      else
        this.form.dtmUse = ''
      if (this.form.vdtmChecked)
        this.form.vdtmUse = 'Y'
      else
        this.form.vdtmUse = ''

      const param = JSON.parse(JSON.stringify(this.form))

      const stripFields = ['searchDtmFr', 'searchDtmTo', 'searchVDtmFr', 'searchVDtmTo']
      _.forEach(stripFields, (name) => param[name] = this.toPure(param[name]))

      if (param.searchDtmFr > param.searchDtmTo) {
        this.$swal({ type: 'warning', text: '신청 시작일자와 종료일자 지정이 잘못되었습니다.' })
        return false
      }
      if (param.searchVDtmFr > param.searchVDtmTo) {
        this.$swal({ type: 'warning', text: '방문 시작일자와 종료일자 지정이 잘못되었습니다.' })
        return false
      }

      const searchInfo = {}
      Object.assign(searchInfo, this.form, { title: this.title })
      this.$store.commit('searchCondition', searchInfo)

      this.$store.commit('loading')
      this.$http.post(`/api/visit/mgList`, param)
        .then(response => {
          if (response.data) {
            console.log(response.data)
            this.visitList = response.data
            //this.config.queryPage(0)
          }
        }).finally(() => {
          this.$store.commit('finish')
        })
    },
    setRToday() {
      this.form.searchDtmFr = this.$moment().format('YYYY-MM-DD')
      this.form.searchDtmTo = this.$moment().format('YYYY-MM-DD')
    },
    setToday() {
      this.form.searchVDtmFr = this.$moment().format('YYYY-MM-DD')
      this.form.searchVDtmTo = this.$moment().format('YYYY-MM-DD')
    },
    popEmp(clear) {
      if (clear === true) {
        this.form.draftUserId = ''
        this.form.draftNm = ''
        this.form.draftUserDut = ''
        this.form.draftUserDept = ''
      }
      this.showEmpModal = true
    },
    receiveEmp(obj) {
      this.form.draftUserId = obj.empNo
      this.form.draftNm = obj.empNm
      this.form.draftUserDut = obj.dutNm
      this.form.draftUserDept = obj.deptNm
    },
    initEmp(force) {
      if (force === true) this.form.draftNm = ''
      if (this.form.draftNm === '') {
        this.form.draftUserId = ''
        this.form.draftUserDut = ''
        this.form.draftUserDept = ''
      }
    },
    setCallPageByParam() {
      if (this.$route.query) {
        for (let member in this.form) {
          if (this.$route.query[member] !== undefined) {
            this.form[member] = this.$route.query[member]
          }
        }
      }
    },
    getFuncUsed() {
      this.$http.get(`/api/func/getFuncUse`, { params: { funcCd: "VISIT_BOOK_YN" } })
        .then(response => {
          this.visitBookYn = response.data[0].adminFuncCd === 'Y' ? true : false
        })
    }
  },
  mounted() {
    if (this.$store.state.searchInfo !== null) {
      if (this.title === this.$store.state.searchInfo.title)
        Object.assign(this.form, this.$store.state.searchInfo)
      else
        this.$store.state.searchInfo = ''
    }
    this.setCallPageByParam()
    this.getPurposeCdCombo()
    this.getVisitTypeCdCombo()
    this.getVisitStatCdCombo()
    this.getFuncUsed()
    this.goSearch()
  },
  computed: {
    configType() {
      if (this.visitBookYn)
        return this.configBook
      else
        return this.config
    }
  },
  watch: {
    'form.searchDtmFr': {
      handler(value) {
        if (this.toPure(value) > this.toPure(this.form.searchDtmTo))
          this.form.searchDtmTo = value
      }
    },
    'form.searchDtmTo': {
      handler(value) {
        if (this.toPure(value) < this.toPure(this.form.searchDtmFr))
          this.form.searchDtmFr = value
      }
    },
    'form.searchVDtmFr': {
      handler(value) {
        if (this.toPure(value) > this.toPure(this.form.searchVDtmTo))
          this.form.searchVDtmTo = value
      }
    },
    'form.searchVDtmTo': {
      handler(value) {
        if (this.toPure(value) < this.toPure(this.form.searchVDtmFr))
          this.form.searchVDtmFr = value
      }
    },
  }
}
</script>

<style scoped>
.desc-content:after {
  clear: both;
  content: '';
  display: block;
}

.btn-wrap {
  margin-bottom: 10px;
}

.desc-content {
  border: 2px solid #9db6c9;
  background: #f9fafc;
  margin: 0 0 20px 0;
  border-radius: 4px;
  padding: 15px 2%;
  clear: both;
}

.desc-content .item {
  float: left;
}

.desc-content .item .desc-item {
  position: relative;
  padding-left: 82px;
  margin-bottom: 8px;
}

.desc-content .item.desc-center .desc-item {
  padding-left: 120px;
}

.desc-content .item .desc-item:last-child {
  margin-bottom: 0;
  height: 25px;
}

.desc-content .item .desc-item .tit {
  position: absolute;
  left: 0;
}

.desc-content .item .desc-item .label-tit {
  font-family: 'NotoM';
  color: #222;
  font-size: 15px;
}

.desc-content .item.desc-left .desc-item {
  padding-left: 90px;
}

.desc-content .item.desc-left .desc-item .desc:after {
  clear: both;
  content: '';
  display: block;
}

.desc-content .item.desc-left .desc-item .desc .datepicker {
  float: left;
}

.desc-content .item.desc-left .desc-item .desc span.wave {
  float: left;
  padding: 0 6px;
}

.desc-content .desc-item .td-s-thumb.search-area:after {
  clear: both;
  content: '';
  display: block;
}

.desc-content .desc-item .td-s-thumb.search-area input,
.desc-content .desc-item .td-s-thumb.search-area .ip-box {
  float: left;
}

.desc-content .item.desc-left .desc-item .desc.select select {
  width: 70%;
}

.desc-content .item.desc-left {
  width: 40%;
}

.desc-content .item.desc-center {
  width: 40%;
  padding-right: 40px;
}

.desc-content .item.desc-right {
  width: 20%;
}

.desc-content .item .desc-item .select select,
.desc-content .item .desc-item .input-box input {
  width: 70%;
}

.desc-content .item.desc-right .desc-item .select select,
.desc-content .item.desc-right .desc-item .input-box input {
  width: 100%;
}

.search-area input {
  position: relative;
}

.search-area .icon {
  position: absolute;
  right: 8px;
  top: 1px;
  z-index: 100;
  cursor: pointer;
  font-size: 16px;
  color: #555;
}

.search-border .td-s-thumb {
  position: relative;
  display: inline-block;
  width: 48%;
}

.search-border .td-s-thumb.search-area>input,
.search-border .td-s-thumb.search-area>.ip-box .search-border .td-s-thumb.search-area>button {
  float: left;
}

.search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
  width: 65%;
  margin-left: 6px;
}

.remove_text {
  margin-left: 0;
}

.contents div.gridbox_material.gridbox .xhdr {
  border-bottom: 1px solid #dfdfdf;
}

@media (max-width: 1580px) {
  .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
    width: 50%;
  }
}

textarea {
  height: 80px;
}

.search-form .form-group {
  margin-bottom: 8px
}
</style>
